import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import './ComprarMoto.css';

// Importación de logos
import subaruLogo from '../../images/subaru-logo.png';
import suzukiLogo from '../../images/suzuki-logo.png';

export default function ComprarMoto() {
    const [tab, setTab] = useState('subaru');

    const content = {
        subaru: {
            brand: "SUBARU",
            logo: subaruLogo,
            tag: "RENDIMIENTO STI",
            title: "INGENIERÍA AWD",
            desc: "Tracción integral simétrica de serie en todos sus modelos, pensada para mayor estabilidad, seguridad y capacidad en todo tipo de caminos.",
            features: ["Tracción Integral", "Motor Boxer", "Seguridad Activa"],
            stats: { potencia: "100%", traccion: "100%", seguridad: "100%" },
            link: "/stock/subaru",
            color: "#FF0006"
        },
        suzuki: {
            brand: "SUZUKI",
            logo: suzukiLogo,
            tag: "TECNOLOGÍA ALLGRIP",
            title: "INGENIERÍA ALLGRIP",
            desc: "La tracción se adapta a diferentes terrenos para brindarte mayor control, seguridad y confianza tanto en la ciudad como fuera del asfalto.",
            features: ["Tracción", "Robustez", "Versatilidad"],
            stats: { traccion: "100%", robustez: "100%", versatilidad: "100%" },
            link: "/stock/suzuki",
            color: "#000000"
        }
    };

    return (
        <section className="ido-light-interactive" style={{ padding: '40px 0' }}>
            {/* Estilos específicos para arreglar el responsive */}
            <style>
                {`
                .ido-interactive-grid {
                    display: flex;
                    flex-direction: row;
                    gap: 40px;
                }

                @media (max-width: 991px) {
                    .ido-interactive-grid {
                        flex-direction: column !important;
                        gap: 20px !important;
                    }
                    .ido-brand-panel {
                        width: 100% !important;
                    }
                    .ido-tabs-vertical {
                        flex-direction: row !important;
                        overflow-x: auto !important;
                        padding-bottom: 15px;
                        gap: 12px !important;
                        scrollbar-width: none; /* Firefox */
                    }
                    .ido-tabs-vertical::-webkit-scrollbar {
                        display: none; /* Chrome/Safari */
                    }
                    .ido-tab-btn {
                        min-width: 140px;
                        padding: 15px !important;
                    }
                    .tab-brand-img {
                        width: 100px !important;
                        height: 50px !important;
                    }
                    .display-title {
                        font-size: 1.8rem !important;
                    }
                    .ido-btn-black {
                        width: 100%;
                        justify-content: center;
                    }
                }
                `}
            </style>

            <div className="ido-binary-light" style={{ textAlign: 'center', opacity: 0.2, marginBottom: '20px' }}>
                0101010101010101
            </div>

            <div className="ido-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div className="ido-interactive-grid">

                    {/* LADO IZQUIERDO: SELECTOR DE MARCAS */}
                    <div className="ido-brand-panel" style={{ width: '320px', flexShrink: 0 }}>
                        <span className="ido-label" style={{ marginBottom: '20px', display: 'block', fontWeight: 'bold', fontSize: '0.8rem', letterSpacing: '1px' }}>
                            SELECCIONAR MARCA
                        </span>
                        <div className="ido-tabs-vertical" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {Object.keys(content).map((key) => (
                                <button
                                    key={key}
                                    className={`ido-tab-btn ${tab === key ? 'active' : ''}`}
                                    onClick={() => setTab(key)}
                                    style={{
                                        padding: '30px 20px',
                                        height: 'auto',
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: tab === key ? '#f8f8f8' : 'transparent',
                                        border: tab === key ? `2px solid ${content[key].color}` : '1px solid #eee',
                                        borderRadius: '8px',
                                        transition: 'all 0.4s ease',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <div className="tab-brand-container" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <img
                                            src={content[key].logo}
                                            alt={content[key].brand}
                                            className="tab-brand-img"
                                            style={{
                                                width: '200px',
                                                height: '80px',
                                                objectFit: 'contain',
                                                transition: 'all 0.4s ease',
                                                filter: tab === key ? 'none' : 'grayscale(100%) opacity(0.3)',
                                                transform: tab === key ? 'scale(1.1)' : 'scale(1)'
                                            }}
                                        />
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* LADO DERECHO: DISPLAY DE DATOS */}
                    <div className="ido-data-display" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className="display-header">
                            <h2 className="display-title" style={{ fontSize: '2.5rem', marginBottom: '15px', fontWeight: '800' }}>
                                {content[tab].title}
                            </h2>
                            <p className="display-desc" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#444' }}>
                                {content[tab].desc}
                            </p>
                        </div>

                        <div className="display-stats" style={{ margin: '30px 0' }}>
                            {Object.entries(content[tab].stats).map(([label, value]) => (
                                <div className="stat-progress-group" key={label} style={{ marginBottom: '18px' }}>
                                    <div className="stat-info" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                        <span style={{ fontWeight: 'bold', letterSpacing: '1px', fontSize: '0.85rem' }}>{label.toUpperCase()}</span>
                                        <span style={{ fontWeight: '900', color: content[tab].color }}>{value}</span>
                                    </div>
                                    <div className="progress-bar-bg" style={{ height: '8px', backgroundColor: '#eee', borderRadius: '4px', overflow: 'hidden' }}>
                                        <div
                                            className="progress-bar-fill"
                                            style={{
                                                width: value,
                                                height: '100%',
                                                backgroundColor: content[tab].color,
                                                transition: 'width 1s cubic-bezier(0.17, 0.67, 0.83, 0.67)'
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="display-footer" style={{ marginTop: 'auto' }}>
                            <div className="features-inline" style={{ display: 'flex', gap: '8px', marginBottom: '30px', flexWrap: 'wrap' }}>
                                {content[tab].features.map((f, i) => (
                                    <span key={i} className="feature-pill" style={{ padding: '8px 16px', backgroundColor: '#f0f0f0', borderRadius: '4px', fontSize: '0.8rem', fontWeight: '600' }}>
                                        {f}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}